<template>
    <div class="container-fluid pt-2">
        <div v-if="companySettings.hide_orders_from_employees && (userDetails.roles[0].name !=='Admin' || hasPermission('can manage orders'))">
            <div class="d-flex justify-content-center align-items-center">
                <div class="text-center">
                    <img src="/images/embarrassed.png" style="width:40px;" class="img-fluid">
                    <h1 class="text-center py-3">Please talk to admin</h1>
                    <hr />
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row">
                <div class="col-md-3 col-sm-4">
                    <div class="text-left py-3">
                        <h4 class="text-weight-700 text-dark"> Orders</h4>
                    </div>
                </div>
                <div class="col-md-9 col-sm-8">
                    <div class="text-right py-3">
                        <a v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage orders')" class="btn btn-primary btn-sm px-1" @click="switchOrdersAction">Action on Orders</a>
                        <a v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage orders')" class="btn btn-outline-primary btn-sm px-1" @click="withDeletedOrders(true)">Include Deleted Orders</a>
                    </div>
                </div>
            </div>
            <div class="pt-2">
                <!--TODO : RETURN THE STORE SOURCE -->
                <div class="row">
                    <div class="col-md-6 col-12">
                        <form @submit.prevent="completeSearchOrderValue" class="form-inline">
                            <div class="input-group w-100 my-1">
                                <input type="text" ref="search_item_focus" class="form-control" v-model="searchOrderValue" placeholder="Search Items">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="submit">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
                                <template #input="picker" style="width: 100% !important;">
                                                                    <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                                    <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
</template>
                                            </date-range-picker>
                                        </div>
                                    </div>

            </div>
            <div v-if="companySettings.allow_summaries && (userRole==='Admin' || hasPermission('can manage orders'))" class="text-center py-3">
            <div class="d-inline">

                    <span v-for="(value,key) in paymentSummary"
                    class="py-2 px-3 badge badge-secondary text-capitalize mx-1"
                >
                    {{ key }} - {{ convertCurrencyToLocal(value) }}
                </span>


            </div>
            </div>


                    <div v-if="orders.length < 1 && isLoadingOrdersDone" >
                                <div class="d-flex justify-content-center align-items-center">
                                    <div class="text-center">
                                        <img src="/images/embarrassed.png" style="width:20px;" class="img-fluid">
                                        <p class="text-center py-3">Sorry No Orders Made</p>
                                        <div class="btn-group">
                                            <a href="/orders" class="btn btn-sm mx-1 btn-outline-secondary" >Reload <i class="bi bi-arrow-repeat"></i></a>
                                            <a href="/makesale" class="btn btn-sm mx-1 btn-primary" >Make Sale <i class="bi bi-cart"></i></a>
                                        </div>
                                        <hr />

                                    </div>
                                </div>
                    </div>
                    <div v-else-if="orders.length >= 1 && isLoadingOrdersDone " >
                                <div v-if="ordersToAction.selected.length > 0">
                                    <div class="d-inline">
                                        <a v-if="ordersToAction.allSelected===false" @click="selectAllRows" class="btn btn-secondary btn-sm">Select All</a>
                                        <a v-else @click="clearSelected" class="btn btn-outline-secondary btn-sm">Unselect All</a>
                                        <a v-b-modal="'change-order-date'" class="btn btn-primary btn-sm">Change Order Date</a>
                                        <a v-if="userRole==='Admin' || hasPermission('can manage orders')" v-b-modal="'delete-many-orders'" class="btn btn-danger btn-sm">Delete</a>

                                    </div>

                                </div>

                            <b-table
                            v-if="ordersToAction.changeToSelection === false"
                            striped
                                 hover
                                 small
                                 sticky-header="90vh"
                                 :items="items"
                                 :fields="fields"
                                 sort-icon-left
                                 responsive="sm"
                                 class="text-sm"
                                 :tbody-tr-class="ordersRowClass"
                                @row-clicked="onRowClicked">

<template #cell(#)="data">
    <div class="d-inline">
        <p v-if="data.item.status === 1" title="Completed" class="underline-primary" style="display: flex; align-items: center;">
            <span class="text-success text-sm circle-icon-success">
                    <i class="bi bi-check-lg"></i>
                </span> &nbsp;
            <span v-if="data.item.is_verified" class="text-success text-sm circle-icon-success">
                    <i class="bi bi-check-lg"></i>
                 </span>
        </p>
        <p v-else-if="data.item.total_amount !== data.item.balance && data.item.balance > 0" title="Has balance" class="text-dark" style="display: flex; align-items: center;">
            <span class="text-danger circle-icon-warning">
                    <i class="bi bi-circle-half"></i>
                </span>
        </p>
        <p v-else title="Pending payment" class="text-dark" style="display: flex; align-items: center;">
            <span class="text-danger circle-icon-danger">
                    <i class="bi bi-hourglass-split"></i>
                 </span>
        </p>
        <p v-if="data.item?.kitchenorders" class="text-capitalize mb-0">Kitchen Status -   <i class="bi bi-circle-fill mr-1" :class="getStatusColor(data.item?.kitchenorders?.status)" title="Kitchen Status"></i></p>

    </div>
</template>


<template #cell(order)="data">
    <p>
        {{ data.item.order }}
    </p>
    <hr class="m-0" />
    <p>
        <small v-if="data.item && data.item.soldby && data.item.soldby.name" class="text-capitalize">
                                                                 {{ data.item.soldby.name }}
                                                            </small>
    </p>
</template>

<template #cell(created_at)="data">
    <p> {{ formatDate(data.item.created_at,'HH:mm A - DD MMM Y') }}</p>
</template>



<template #cell(total_amount)="data">
    <p> {{convertCurrencyToShillings(data.item.total_amount) }}</p>
</template>

<template #cell(payment_method)="data">
    <!-- <p v-if="data.item.paymentmethod"> {{ data.item.paymentmethod.payment_method }}</p> -->
<p v-if="data.item.paymentmethod && data.item.paymentmethod !== ''">
  <span
    type="button"
    :class="[
      'badge text-capitalize mx-1',
      getPaymentBadgeClass(data.item.paymentmethod.payment_method)
    ]"
  >
    {{ data.item.paymentmethod.payment_method }}
  </span>
</p>

<p v-else-if="data.item.splitorderpayment.length > 0">
  <span
    v-for="(mode, idx) in data.item.splitorderpayment"
    :key="idx"
    type="button"
    :class="[
      'badge text-capitalize mx-1',
      getPaymentBadgeClass(mode.paymentmethod.payment_method)
    ]"
  >
    {{ mode.paymentmethod.payment_method }}
  </span>
</p>

</template>


                            </b-table>
                            <b-table
                            v-else
                            striped
                                 hover
                                 small
                                 sticky-header="90vh"
                                 :items="items"
                                 :fields="fields"
                                 sort-icon-left
                                 responsive="sm"
                                 class="text-sm"
                                 :select-mode="ordersToAction.selectMode"
                                ref="selectableTable"
                                selectable
                                @row-selected="onRowSelected"
                                >

<template #cell(#)="{ rowSelected }">
    <template v-if="rowSelected">
                                                <span aria-hidden="true">&check;</span>
                                                <span class="sr-only">Selected</span>
</template>

<template v-else>
    <span aria-hidden="true">&#x25a2;</span>
    <span class="sr-only">Not selected</span>
</template>
                                </template>


<template #cell(order)="data">
    <p>
        {{ data.item.order }}
    </p>
</template>

<template #cell(created_at)="data">
    <p> {{ formatDate(data.item.created_at,'HH:MM A - DD MMM Y') }}</p>
</template>



<template #cell(total_amount)="data">
    <p> {{convertCurrencyToShillings(data.item.total_amount) }}</p>
</template>

<template #cell(payment_method)="data">
    <!-- <p v-if="data.item.paymentmethod"> {{ data.item.paymentmethod.payment_method }}</p> -->
    <p v-if="data.item.paymentmethod && data.item.paymentmethod !==''">
        <span type="button" :class="{'badge badge-secondary text-capitalize mx-1': data.item.paymentmethod.payment_method === 'Cash', 'badge badge-primary text-capitalize mx-1': data.item.paymentmethod.payment_method !== 'Cash'}">
                                                                {{ data.item.paymentmethod.payment_method }}
                                                             </span>
    </p>
    <p v-else-if="data.item.splitorderpayment.length > 0">
        <span type="button" v-for="mode in data.item.splitorderpayment" :class="{'badge badge-secondary text-capitalize mx-1': mode === 'Cash', 'badge badge-primary text-capitalize mx-1': mode !== 'Cash'}">
                                                                                                {{ mode.paymentmethod.payment_method }}
                                                                                                </span>
    </p>
</template>


                            </b-table>
                                <nav aria-label="Page navigation example" class="float-right mb-5">
                                    <ul class="pagination">
                                        <li class="page-item"><button class="page-link" href="#" v-if="this.current_page !== this.first_page" @click="prevPage"><i class="fas fa-chevron-left"></i><i class="fas fa-chevron-left"></i> &nbsp;Previous</button></li>
                                        <li class="page-item"><button class="page-link disabled" href="#">{{ this.current_page }}</button></li>
                                        <li class="page-item"><button class="page-link" href="#" @click="nextPage" v-if="this.current_page !== this.last_page">Next &nbsp;<i class="fas fa-chevron-right"></i><i class="fas fa-chevron-right"></i></button></li>
                                    </ul>
                                </nav>


                    </div>
                <div v-else>
                    <div class="text-center">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>

                </div>

                </div>





               <b-modal ref="orderDetailsModal" size="lg" hide-footer>

                <div class="text-center" v-if="orderToShow">
                    <h2  v-if="orderToShow.status === 0">
                        <span class="text-danger" v-if="orderToShow.partial===1">
                            <i class="bi bi-circle-half"></i>
                            <span>
                                        Partial
                            </span>
                        </span>
                        <span v-else>
                            <i class="bi bi-exclamation-diamond"></i>
                                    <span>
                                        Pending
                                     </span>
                        </span>

                                    </h2>
                                    <h2 class="text-success" v-else>
                                        <i class="bi bi-check2-circle"></i>
                                        <i v-if="orderToShow.is_verified" class="bi bi-check2-circle"></i>

                                    <span>
                                 Completed
                                     </span>
                                    </h2>
                                    <hr />

                        <h6 class="font-weight-bold">Order No:  &nbsp; {{orderToShow.order}}</h6>
                        <p class="py-1">Time:&nbsp; <span class="font-weight-bold">{{formatDate(orderToShow.created_at,'hh:mm A')}}</span></p>
                        <p class="py-1">Date:&nbsp; <span class="font-weight-bold">{{formatDate(orderToShow.created_at,'DD-MMM-YYYY')}}</span></p>
                        <p v-if="orderToShow.soldby" class="py-1">Order by:&nbsp  <span class="font-weight-bold text-capitalize">{{orderToShow.soldby.name}}</span></p>
                        <p class="py-1" v-if="orderToShow.deleted_at">Deleted on:&nbsp; <small>{{formatDate(orderToShow.deleted_at,'hh:mm A DD-MMM-YYYY')}}</small></p>
                        <p  v-if="orderToShow.status === 1 && orderToShow.partial === 0" class="py-1">Payment:&nbsp; <span class="font-weight-bold text-capitalize">{{orderToShow.paymentmethod.payment_method}}</span></p>

                    <p><span v-if="orderToShow.splitorderpayment.length > 0" class="font-weight-bold text-capitalize">
                             <span v-for="splitPayment in orderToShow.splitorderpayment">
                            [{{ splitPayment.paymentmethod.payment_method }} - {{ convertCurrencyToShillings(splitPayment.paid_amount) }} ]
                            </span>
                            </span></p>
                        <div class="text-left" v-if="customer">
                        <p v-if="customer" class="py-1">Customer:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{customer.full_name}} </p>
                        <p v-if="customer.phone" class="py-1">Customer phone:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{customer.phone}} </p>
                        <p v-if="customer.email" class="py-1">Customer email:&nbsp; <span class="font-weight-bold"></span>&nbsp;{{customer.email}} </p>
                        </div>
                        </div>
                            <div class="text-left" v-if="orderToShow.deleted_at ===null">


                                <div class="pt-1 pb-2" v-if="orderToShow.status === 0  && orderToShow.partial === 0">


                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div v-if="companySettings.has_kds" class="d-inline">

                                                <a v-if="(userRole==='Admin' || hasPermission('can manage orders'))" :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-block btn-primary">Complete Order</a>
                                                <a v-else :href='"/print_invoice/" + orderToShow.id'  class="btn btn-block btn-outline-secondary">Print Customer Receipt</a>
                                            </div>
                                            <div v-else class="d-inline">

                                                <a :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-block btn-primary">Complete Order</a>
                                            </div>

                                        </div>
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div class="dropdown">
                                                <a class="btn btn-outline-secondary btn-block dropdown-toggle"  type="button" data-toggle="dropdown" aria-expanded="false">
                                                     More ...
                                                </a>
                                                <div class="dropdown-menu">

                                                    <a :href='"makesale?add-to-order=" + orderToShow.id'  class="dropdown-item">Add More Items </a>
                                                    <a v-if="companySettings.has_kds" :href='"/print_invoice/" + orderToShow.id + "?order-receipt=true"'  class="dropdown-item">Print Kitchen Order</a>
                                                    <a v-else :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                                    <a :href='"/customer-order-view/" + orderToShow.id'  class="dropdown-item">View Receipt</a>
                                                    <a style="color: #28D146;" target="_blank"  v-if="customer && customer.phone" :href='"https://wa.me/" + convertToInternational(customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ userDetails.company.name +"%20https://app.dukakit.com/customer-order-view/" + orderToShow.id + "?from=whatsapp&utm=whatsapp"'  class="dropdown-item"><i class="bi bi-whatsapp"></i>&nbsp Share via whatsapp</a>

                                                    <a v-if="customer && customer.phone" v-b-modal="'textmessage-modal'" href="#" class="dropdown-item">Send SMS</a><div class="dropdown-divider"></div>

                                                    <a class="dropdown-item text-danger"  v-if="(userRole==='Admin' || hasPermission('can manage orders')) && (!orderToShow.deleted_at)" @click="deleteOrderConfirm(orderToShow)" >Delete Order</a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div class="pt-1 pb-2" v-if="orderToShow.status === 1 || orderToShow.partial === 1">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-6">
                                            <div v-if="orderToShow.partial === 1 && orderToShow.status===0">

                                                <a v-if="(userRole==='Admin' || !hasPermission('can complete order'))" :href="'/checkout/' + orderToShow.id + '?source='+sourceUrl" class="btn btn-primary btn-outline-primary btn-block">Complete Order</a>
                                                  <a v-else :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                            </div>
                                            <div v-else>
                                                <a :href='"/print_invoice/" + orderToShow.id'  class="btn btn-block btn-primary">Print Receipt</a>
                                            </div>
                                        </div>
                                    <div class="col-sm-6 col-md-6 col-6">
                                        <div class="dropdown">
                                            <a class="btn btn-outline-secondary btn-block dropdown-toggle"  type="button" data-toggle="dropdown" aria-expanded="false">
                                            More ...
                                            </a>
                                            <div class="dropdown-menu">
                                                <!-- <a v-if="orderToShow.partial === 1" :href='"makesale?add-to-order=" + orderToShow.id'  class="dropdown-item">Add More Items </a> -->
                                                <a v-if="orderToShow.partial === 1 && orderToShow.status===0" :href='"/print_invoice/" + orderToShow.id'  class="dropdown-item">Print Receipt</a>
                                                <a style="color: #28D146;" target="_blank"  v-if="customer && customer.phone" :href='"https://wa.me/" + convertToInternational(customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ userDetails.company.name +"%20https://app.dukakit.com/customer-order-view/" + orderToShow.id + "?from=whatsapp&utm=whatsapp"'  class="dropdown-item"><i class="bi bi-whatsapp"></i>&nbsp Share via whatsapp</a>
                                                <a :href='"/customer-order-view/" + orderToShow.id'  class="dropdown-item">View Receipt</a>
                                                <a  href="#" v-if="companySettings.has_order_verification && orderToShow.is_verified === 0" @click="markOrderasVerified(orderToShow.id)" class="dropdown-item">Mark as Collected</a>

                                                <a v-if="customer && customer.phone" v-b-modal="'textmessage-modal'" href="#" class="dropdown-item">Send SMS</a>

                                                <a v-else @click="customerModalOpen" href="#" class="dropdown-item">Assign To Customer</a><div class="dropdown-divider"></div>

                                                <a class="dropdown-item text-danger"  v-if="(userRole==='Admin' || hasPermission('can manage orders')) && (!orderToShow.deleted_at)" @click="deleteOrderConfirm(orderToShow)" >Delete Order</a>

                                            </div>
                                        </div>
                                    </div>
                                    </div>

                                </div>

                            </div>






                    <hr/>
                    <div class="text-left">
                        <h5>
                            Product order list
                        </h5>
                    </div>
                    <table class="table table-hover">
                        <thead>

                            <td>#</td>
                            <td>Item</td>
                            <td>Qty</td>
                            <td v-if="userRole==='Admin'">Profits</td>
                            <td>Amount</td>
                            <td colspan="1"></td>
                        </thead>

                        <tbody>
                        <tr  v-if="orderItem.product || orderItem.grouped_inventory" v-for="(orderItem,index) in orderToShow.orders" >
                            <td>
                                <h6>{{index + 1}}</h6>
                            </td>
                            <td v-if="orderItem.grouped_inventory">
                                <h6>{{orderItem.grouped_inventory.group_title}}</h6>
                                <hr class="m-0">
                                <p v-if="orderItem.grouped_inventory.grouped_items " v-for="g_item in orderItem.grouped_inventory.grouped_items">

                                   <small v-if="g_item.product">
                                    <span v-if="g_item.product.can_be_sold">{{g_item.product.product }}  - {{ g_item.count }}</span>
                                </small>
                                   <small v-else class="text-danger">Item could be missing</small>
                                </p>

                            </td>
                            <td v-else>
                                <div v-if="orderItem.product.deleted_at">
                                    <h6 class="text-danger">{{orderItem.product.product}}</h6>
                                    <span class="text-danger">**Deleted**</span>
                                </div>
                                <div v-else>
                                    <h6>{{orderItem.product.product}}</h6>
                                    <div v-if="orderItem.sold_by">
                                        <hr class="my-1"/>
                                    <small >{{ orderItem.sold_by.name }}</small>
                                    </div>


                                </div>

                            </td>
                            <td><h6>{{orderItem.qty}}</h6></td>
                            <td v-if="userRole==='Admin'"><h6 class="text-primary">{{orderItem.profits}}</h6></td>
                            <td v-if="orderItem.is_retail === 1">
                                <h6 v-if="orderItem.product">
                                    {{orderItem.qty * ((orderItem.selling_price !== null ) ? orderItem.selling_price : orderItem.product.ppu)}}</h6>
                                <h6 v-else>{{orderItem.qty * orderItem.grouped_inventory.cost}}</h6>
                            </td>
                            <td v-else-if="orderItem.is_retail === 0">
                                <h6 v-if="orderItem.product">{{orderItem.qty * ((orderItem.selling_price !== null ) ? orderItem.product.wholesale_sp : orderItem.product.wholesale_sp)}}</h6>
                                <h6 v-else>{{orderItem.qty * orderItem.grouped_inventory.wholesale}}</h6>

                            </td>
                            <td colspan="1">

                                <a href="#"  data-toggle="dropdown" aria-expanded="false">
                                    <i class="bi bi-three-dots-vertical"></i>
                                            </a>
                                            <div class="dropdown-menu" v-if="(userRole==='Admin' || hasPermission('can manage orders'))">

                                                <a class="dropdown-item"  v-if="(!orderToShow.deleted_at)" v-b-modal="'re-assign-order'" @click="order_to_assign.orderId = orderItem.id" >Re-assign</a>
                                                <a class="dropdown-item text-danger"  v-if="(!orderToShow.deleted_at) && (orderToShow.partial === 0 && orderToShow.status===0)"  @click="deleteSingleOrder(orderItem.id)" >Remove Item</a>
                                                <a class="dropdown-item text-danger"  v-if="(!orderToShow.deleted_at) && (orderToShow.partial === 1 || orderToShow.status===1)"  @click="deleteSingleOrder(orderItem.id)" >Return Item</a>

                                                <a class="dropdown-item text-dark"  v-if="companySettings.has_kds"  @click="sendItemToKitchen(orderItem.id)" >Send To Kitchen</a>
                                                <a class="dropdown-item text-success"  v-if="companySettings.has_kds"  @click="markKDSItemAsDone(orderItem.id)" >Kitchen Done</a>

                                            </div>
                                            <div class="dropdown-menu" v-else>

                                                <a class="dropdown-item text-dark"  v-if="companySettings.has_kds"  @click="sendItemToKitchen(orderItem.id)" >Send To Kitchen</a>
                                                <a class="dropdown-item text-success"  v-if="companySettings.has_kds && orderItem.kitchen_status !=='done'"  @click="markKDSItemAsDone(orderItem.id)" >Kitchen Done</a>

                                            </div>
                            </td>
                        </tr>
                        <tr v-else>
                            <td>#</td>
                            <td><p class="text-danger"> <small>Seems the item sold was deleted from inventory</small></p></td>
                         </tr>


                        </tbody>
                    </table>
                        <table class="table table-hover">

                            <tbody>
                                <tr>


                                <td class="text-left">
                                    <h6 class="py-1">   All Item/Services</h6>
                                </td>
                                <td class="text-right">
                                    <h5 class="py-1 text-dark"> {{totalQuantity}}</h5>
                                </td>

                                </tr>
                                <tr v-if="userRole==='Admin'">


                                <td class="text-left">
                                    <h6 class="py-1">   Profits</h6>
                                </td>
                                <td class="text-right">
                                    <h5 class="py-1 text-success">{{convertCurrencyToLocal(orderToShow.total_profit)}}</h5>
                                </td>

                                </tr>

                                <tr v-if="orderToShow.discount !==null">


                                <td class="text-left">
                                    <h6 class="py-1">   Discount</h6>
                                </td>
                                <td class="text-right">
                                    <h5 class="py-1 text-dark">{{convertCurrencyToLocal(orderToShow.discount)}}</h5>
                                </td>

                                </tr>
                                <tr v-if="orderToShow.partial && orderToShow.balance > 0">


                                <td class="text-left">
                                    <h6 class="py-1">   Balance</h6>
                                </td>
                                <td class="text-right">
                                    <h5 class="py-1 text-success">{{convertCurrencyToLocal(orderToShow.balance)}}</h5>
                                </td>

                                </tr>

                            <tr>


                                <td class="text-left">
                                    <h5 class="py-1">Grand Total</h5>
                                </td>
                                <td class="text-right">
                                    <h5 class="py-1 text-primary font-weight-bold">{{convertCurrencyToLocal(orderToShow.total_amount)}}</h5>
                                </td>

                            </tr>




                            </tbody>
                        </table>
                            <hr />
                            <div class="container">
                                <div class="float-right">
                                <b-button v-b-modal.modal-5 variant="outline-primary" size="sm"  >Add a Note &nbsp; <i class="bi bi-pencil"></i></b-button>
                            </div>
                            </div>


                            <h5>Notes</h5>
                            <ul class="list-unstyled">
                                <li class="py-2 px-1 border" v-for="note in orderToShow.ordernotes"><span class="text-capitalize">{{ note.user.name }} - </span>{{ note.note }} &nbsp; <a @click="deleteOrderNote(note.id)" class="text-danger float-right"><i class="bi bi-trash3"></i></a></li>
                            </ul>

                             <hr />

               </b-modal>
               <b-modal ref="createNoteModal" id="modal-5" hide-footer>
                <h5>Add Note</h5>
                <form @submit.prevent="createNote">
                    <div class="form-group">

                    <textarea class="form-control" id="exampleFormControlTextarea1" v-model="noteForm.noteText" rows="3" placeholder="Enter your note..."></textarea>
                </div>

                    <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="noteForm.addToReceipt" class="custom-control-input" id="customSwitch1">
                    <label class="custom-control-label" for="customSwitch1">Add to Receipt</label>
                    </div>


                    <div class="form-group">
                        <button class="btn btn-outline-primary btn-block btn-sm my-2">Save Note</button>
                    </div>
                </form>

                </b-modal>
               <b-modal id="re-assign-order" hide-footer>
                <h5>Select Employee to Assign</h5>

                <form @submit.prevent="reAssignOrder">
                    <div class="form-group">
                        <select class="form-control" v-model="order_to_assign.employeeToAssign">
                            <option value="null">Select Employee</option>
                            <option v-for="employee in employees" :value='employee.users.id'>{{ employee.users.name }}</option>
                        </select>

                    </div>


                    <div class="form-group">
                        <button class="btn btn-outline-primary btn-block btn-sm my-2">Save & Apply</button>
                    </div>
                </form>

                </b-modal>
                </div>




      <b-modal id="change-order-date" hide-footer>
        <div class="py-2">
            <h5>Change Orders date</h5>
            <p><small>Make sure you have selected the correct orders</small></p>
        </div>
        <date-range-picker :auto-apply="autoApply" :ranges="ranges" v-model="ordersToAction.changeOrderDatePicked" :single-date-picker=true  :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
<template #input="picker" style="width: 100% !important;">
    <p v-if="picker.startDate !==null && picker.endDate !==null">
        {{ formatDate(picker.startDate,'DD-MMM-YYYY') }}</p>
    <p v-else><i class="bi bi-calendar-event"></i> Select Date</p>
</template>
        </date-range-picker>

        <div class="text-center py-2">

            <button @click="changeOrdersDate" v-if="ordersToAction.changeOrderDatePicked.startDate !==null" class="btn btn-primary btn-sm">Move The selected Orders to - {{ formatDate(ordersToAction.changeOrderDatePicked.startDate,'DD-MMM-YYYY') }}</button>
            <button v-else  class="btn btn-primary btn-sm " disabled>Move The selected orders</button>

        </div>
      </b-modal>




        <b-modal ref="deleteconfirm_modal" id="modal-center" centered hide-footer>
            <div class="container text-center">
                <h5 class="py-4">Are you sure you want to delete this order?</h5>
                <a @click="confirmDeleteOrder"
                    class="btn btn-danger"
                    :class="{ 'disabled': !confirmIsNotComplete }"
                    :disabled="!confirmIsNotComplete">
                    Yes Delete!
                    </a>

            </div>

        </b-modal>
        <b-modal ref="deleteManyOrders" id="delete-many-orders" centered hide-footer>
            <div class="container text-center">
                    <h1><i class="bi bi-x-circle"></i></h1>
                <h5 class="py-4">Are you sure you want to delete these order?</h5>
            <a @click="confirmDeleteManyOrders" class="btn btn-danger">Yes Delete!</a>
            </div>

        </b-modal>
        <b-modal id="textmessage-modal" ref="textmessage_modal" hide-footer>
                <div class="text-center">
                    <h2>Send SMS to Customer</h2>
                </div>
                <form @submit.prevent="sendSMSToCustomer">

                    <div class="form-group">
                        <textarea v-if="smsForm.addMessageBody" class="form-control" v-model="smsForm.message" required>start typing</textarea>
                    </div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="smsForm.addMessageBody" type="checkbox" >
                            <label class="form-check-label" for="defaultCheck1">
                               Add a message body
                            </label>

                            </div>

                    </div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="smsForm.add0rderLink" type="checkbox" >
                            <label v-if="smsForm.addMessageBody" class="form-check-label" for="defaultCheck1">
                               Include order link
                            </label>
                            <label class="form-check-label" for="defaultCheck1">
                               Send the order link only
                            </label>
                            </div>

                    </div>
                    <div class="my-2 form-group">
                        <button v-if="smsForm.addMessageBody" type="submit" class="btn btn-block btn-outline-primary"> Send SMS</button>
                        <button v-else type="submit" class="btn btn-block btn-outline-primary"> Send Order Link</button>
                    </div>
                </form>

         </b-modal>
         <b-modal ref="customerSearch" hide-footer>
            <div class="text-center"><h5>Add Customer</h5></div>
    <div class="py-3">
                <input v-model="customerData.searchTerm" type="text" class="form-control"
                    placeholder="Search by name, email, or phone number">
                <table class="table table-striped table-sm"
                    v-if="customerData.customer.length > 0 && customerData.searchTable===true">
                    <thead>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>

                    </thead>
                    <tbody>
                        <tr v-for="customer in customerData.customer" :key="customer.id"
                            @click="customerRowSelected(customer)">
                            <td>{{ customer.full_name }}</td>
                            <td>{{ customer.phone }}</td>
                            <td>{{ customer.email }}</td>



                        </tr>
                    </tbody>

                </table>

            </div>
            <p>Can't find Customer? &nbsp;<a href="#" v-b-modal="'new_customer_form'" >Add New Customer</a></p>

  </b-modal>
  <b-modal ref="customerdetails" id="new_customer_form" hide-footer >

 <form v-on:submit.prevent="newCustomer">
     <div class="form-row py-1">
         <div class="col-12">

             <input class="form-control border-bottom"  v-model="customerform.name"  type="text" placeholder="Full Name" required/>
             <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
         </div>
     </div>
     <div class="form-group py-1">

         <input class="form-control border-bottom" name="c_email" v-model="customerform.email" type="email" placeholder="Email"/>


     </div>
     <div class="form-group">
         <vue-tel-input :placeholder="712345678" v-model="customerform.phone"></vue-tel-input>
         <!--<input class="form-control border-bottom"   v-model="customerform.phone" type="text" placeholder="Phone Number"/>-->


     </div>

     <div class="form-group pt-3">
         <button class="btn btn-primary btn-block">Add Customer</button>
     </div>
 </form>
</b-modal>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import utils from '../utils/utils';
    import format from 'date-fns/format'
    import {
        mapGetters
    } from 'vuex'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    export default {
        name: "AllOrders",
        components: {
            DateRangePicker
        },
        props: [
            'orderNumberUrl',
            'limitUrl',
            'hasBalanceUrl',
            'completedUrl',
            'partialUrl',
            'modeOfPaymentUrl',
            'hasDiscountUrl'
        ],
        data() {
            return {
                page: 1,
                first_page: 1,
                last_page: null,
                current_page: '',
                next_page_url: '',
                current_page_url: '',
                prev_page_url: '',
                daterange: '',
                tosearch: '',
                dateFormat: 'D-MM-YYYY',
                dateOne: '',
                dateTwo: '',
                orders: '',
                selectedorder: '',
                orderItems: '',
                order_id: '',
                customer: '',
                orderToShow: '',
                searchOrderValue: '',
                ordersource: '',
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                smsForm: {
                    message: '',
                    add0rderLink: true,
                    addMessageBody: false
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
                isLoadingOrdersDone: false,
                confirmIsNotComplete: true,
                paymentSummary: [],
                items: [],
                fields: [{
                        key: '#'
                    },
                    {
                        key: 'order',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Time',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Date',
                        sortable: true
                    },
                    {
                        key: 'total_amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'payment_method',
                        label: 'Mode',
                        sortable: false
                    },
                ],
                userRole: 'employee',
                orderToDelete: '',
                noteForm: {
                    addToReceipt: false,
                    noteText: '',
                },
                companySettings: {},
                totalQuantity: 0,
                ordersToAction: {
                    changeToSelection: '',
                    selected: [],
                    selectMode: 'multi',
                    clickedCount: 0,
                    allSelected: false,
                    changeOrderDatePicked: {
                        startDate: null,
                    }
                },
                employees: {},
                order_to_assign: {
                    orderId: '',
                    employeeToAssign: null,
                },
                customerData: {
                    searchTerm: '',
                    filteredCustomers: '',
                    searchTable: false,
                    customer: {}
                },
                customerform: {
                    name: '',
                    phone: '',
                    email: '',
                },
                searchTimeout: '',
                sourceUrl: '',
            }
        },
        computed: {
            ...mapGetters(['userDetails'])
        },
        mounted() {
            //
            this.current_page_url = '/api/allorders';
            // this.ordersToAction.changeToSelection = (this.$route.query['bulk-action']) ? this.$route.query['bulk-action'] : false;
            this.bulkOrdersAction();
            this.loadorderDetails();
            this.getUserCompanySettings();
            this.fetchEmployees();
            this.getUser();
            this.setSource()
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                this.redirectToSource()
            })
        },
        watch: {
            dateRange(after, before) {
                if (this.dateRange.startDate && this.dateRange.endDate) {
                    // Get the existing query parameters
                    const urlParams = new URLSearchParams(window.location.search);
                    // Check if the 'bulk-action' parameter exists
                    urlParams.set('start-date', this.dateRange.startDate);
                    urlParams.set('end-date', this.dateRange.endDate);
                    // Build the new URL with the updated query parameters
                    const newURL = '/orders?' + urlParams.toString();
                    // Redirect to the new URL
                    window.location.replace(newURL);
                }
            },
            'customerData.searchTerm': function() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.customerData.searchTable = true
                    this.getCustomers();
                }, 500); // Debounce delay (500ms)
            }
        },
        methods: {
            async fetchEmployees() {
                try {
                    this.employees = await utils.fetchEmployees()
                } catch (e) {
                    console.log(e)
                }
            },
            getPaymentBadgeClass(method) {
            if (!method) return 'badge-dark' // handle null/undefined safely

            const pMethod = method.toLowerCase().trim()

            switch (pMethod) {
                case 'cash':
                return 'badge-secondary'

                case 'm-pesa':
                case 'mpesa':
                return 'badge-success'

                case 'card':
                case 'cards':
                return 'badge-primary'

                case 'bank':
                return 'badge-info'

                default:
                return 'badge-dark' // ✅ fallback default
            }
            },
            setSource() {
                const urlParams = new URLSearchParams(window.location.search);
                this.sourceUrl = urlParams.get('source');
            },
            customerRowSelected(customer) {
                this.assignOrderToCustomer(customer.id, this.orderToShow.id);
            },
            redirectToSource() {
                const urlParams = new URLSearchParams(window.location.search);
                const source = urlParams.get('source');
                if (source) {
                    // Redirect to the source URL
                    window.location.href = source;
                }
            },
            markOrderasVerified(orderId) {
                axios.post('/api/verify-order', {
                    orderId: orderId
                }).
                then(result => {
                    if (result.status === 200) {
                        window.location.reload()
                    }
                }).catch(error => {
                    console.error('Error:', error);
                    if (error.response) {
                        console.error('Response Data:', error.response.data);
                        console.error('Status:', error.response.status);
                        console.error('Headers:', error.response.headers);
                    } else if (error.request) {
                        console.error('Request:', error.request);
                    } else {
                        console.error('Error Message:', error.message);
                    }
                });
            },
            newCustomer() {
                axios.post('/api/newcustomer', {
                    phone_no: this.customerform.phone,
                    email: this.customerform.email,
                    f_name: this.customerform.name
                }).
                then(result => {
                    // now send message to customer
                    this.$refs['customerdetails'].hide();
                    this.assignOrderToCustomer(result.data.customer_id, this.orderToShow.id);
                    this.$refs['customerSearch'].hide();
                }).catch();
            },
            assignOrderToCustomer(customerId, orderId) {
                axios.put('/api/order-details', {
                    order_id: orderId,
                    customer_id: customerId,
                }).then(result => {
                    if (result.status === 200) {
                        this.$toasts.push({
                            'type': "success",
                            "message": "Customer added successfully"
                        })
                        this.$refs.customerSearch.hide()
                    }
                });
            },
            customerModalOpen() {
                this.getCustomers();
                this.$refs.customerSearch.show()
            },
            getCustomers() {
                axios.get(`/api/allcustomers?search=${this.customerData.searchTerm}`)
                    .then(result => {
                        this.customerData.customer = result.data.data;
                    });
            },
            reAssignOrder() {
                axios.post('/api/re-assign-order', { ...this.order_to_assign
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            deleteSingleOrder(id) {
                axios.post('/api/remove-item-from-order', {
                    orderItemId: id
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            async markKDSItemAsDone(id) {
                await axios.post('/api/update-kds-order-item', {
                    orderItemId: id,
                    orderId: this.orderToShow?.id,
                    orderItems: this.orderToShow?.orders
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            async sendItemToKitchen(id) {
                await axios.post('/api/update-kds-order-item', {
                    orderItemId: id
                }).then(results => {
                    if (results.status === 200) {
                        window.location.href = '/orders?order-number=' + this.orderToShow.id
                    }
                }).catch(error => {})
            },
            onRowClicked(items) {
                this.$refs.orderDetailsModal.show()
                this.orderDetails(items.id);
            },
            ordersRowClass(items) {
                if (items.deleted_at !== null) {
                    return 'table-danger'
                }
            },
            getUserCompanySettings() {
                this.companySettings = this.userDetails.company.companysettings
            },
            convertToInternational(number) {
                // Assuming the local number starts with '0' and has 10 digits
                if (number.startsWith('0') && number.length === 10) {
                    return '254' + number.substring(1);
                } else {
                    return number
                }
            },
            hasPermission(permissionName) {
                return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
            withDeletedOrders(btnClick = false) {
                if (btnClick) {
                    const urlParams = new URLSearchParams(window.location.search);
                    if (urlParams.has('withTrashed')) {
                        // The parameter exists but is not equal to 'true'
                    } else {
                        urlParams.set('withTrashed', '1'); // Set the parameter to '1'
                        const newURL = `${window.location.pathname}?${urlParams.toString()}`;
                        window.location.replace(newURL);
                        this.displayOrders()
                    }
                }
            },
            bulkOrdersAction() {
                // Get the URL query parameters
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                if (urlParams.has('bulk-action')) {
                    // Get the value of the 'bulk-action' parameter
                    const bulkActionValue = urlParams.get('bulk-action');
                    if (bulkActionValue !== null || bulkActionValue !== '') {
                        if (bulkActionValue === 'true') {
                            this.ordersToAction.changeToSelection = true
                        }
                        if (bulkActionValue === 'false') {
                            this.ordersToAction.changeToSelection = false
                        }
                    } else {
                        window.location.replace('/orders')
                    }
                } else {
                    this.ordersToAction.changeToSelection = false
                }
            },
            switchOrdersAction() {
                // Get the existing query parameters
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                const bulkActionValue = urlParams.get('bulk-action');
                const newBulkActionValue = bulkActionValue === 'true' ? 'false' : 'true';
                // Update the 'bulk-action' parameter in the query
                urlParams.set('bulk-action', newBulkActionValue);
                // Build the new URL with the updated query parameters
                const newURL = '/orders?' + urlParams.toString();
                // Redirect to the new URL
                window.location.replace(newURL);
            },
            onRowSelected(items) {
                this.ordersToAction.selected = items
            },
            async changeOrdersDate() {
                await axios.post('/api/change-orders-date', { ...this.ordersToAction
                }).then(
                    results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }
                ).catch()
            },
            async confirmDeleteManyOrders() {
                await axios.post('/api/delete-many-orders', { ...this.ordersToAction
                }).then(
                    results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }
                ).catch()
            },
            selectAllRows() {
                this.$refs.selectableTable.selectAllRows()
                this.ordersToAction.allSelected = true;
            },
            clearSelected() {
                this.$refs.selectableTable.clearSelected()
            },
            completeSearchOrderValue(after, before) {
                this.displayOrders();
            },
            sendSMSToCustomer() {
                if (this.smsForm.message !== '' || this.smsForm.add0rderLink) {
                    axios.post('/api/send-sms-to-customer', {
                        customer: this.customer,
                        message: (this.smsForm.add0rderLink) ? this.smsForm.message + '\n' + 'https://app.dukakit.com/customer-order-view/' + this.orderToShow.id : this.smsForm.message,
                    }).then(results => {
                        if (results.delivery === 'success') {
                            this.$toasts.push({
                                'type': "success",
                                "message": "Message sent successfully"
                            })
                        }
                        this.$refs.textmessage_modal.hide()
                    })
                } else {
                    this.$toasts.push({
                        'type': "error",
                        "message": "You need to add a message or send link only"
                    })
                }
            },
            createNote() {
                axios.post('/api/add-note-to-order', { ...this.noteForm,
                    orderId: this.orderToShow.id
                }).then(results => {
                    if (results.status === 200)
                        this.$refs.createNoteModal.hide()
                    this.orderDetails(this.orderToShow.id)
                })
            },
            deleteOrderNote(noteId) {
                axios.delete('/api/delete-note/' + noteId).then(results => {
                    if (results.status === 200)
                        this.orderDetails(this.orderToShow.id)
                })
            },
            getUser() {
                this.userRole = this.userDetails.roles[0].name
            },
            deleteOrderConfirm(order) {
                this.orderToDelete = order
                this.$refs.deleteconfirm_modal.show()
            },
            async confirmDeleteOrder() {
                this.confirmIsNotComplete = false
                await axios.delete("/api/delete-order/" + this.orderToDelete.id)
                    .then(results => {
                        if (results.status === 200) {
                            window.location.replace('/orders')
                        }
                    }).catch(errors => {})
            },
            displayOrders() {
                const urlParams = new URLSearchParams(window.location.search);
                axios.get(this.current_page_url, {
                        params: {
                            'source': this.ordersource,
                            'search': this.searchOrderValue,
                            startdate: this.dateRange.startDate,
                            enddate: this.dateRange.endDate,
                            limit: (this.limitUrl) ? this.limitUrl : '',
                            completed: (this.completedUrl) ? this.completedUrl : '',
                            partial: (this.partialUrl) ? this.partialUrl : '',
                            has_balance: (this.hasBalanceUrl) ? this.hasBalanceUrl : '',
                            has_discount: (this.hasDiscountUrl) ? this.hasDiscountUrl : '',
                            has_discount: (this.hasDiscountUrl) ? this.hasDiscountUrl : '',
                            withTrashed: (urlParams.has('withTrashed')) ? 1 : 0,
                            unattended: (urlParams.has('un-attended')) ? urlParams.get('un-attended') : 0,
                        }
                    })
                    .then(result => {
                        this.last_page = result.data.orders.last_page_url;
                        this.current_page = result.data.orders.current_page;
                        this.next_page_url = result.data.orders.next_page_url;
                        this.prev_page_url = result.data.orders.prev_page_url;
                        this.orders = result.data.orders.data;
                        // let orderItems = [];
                        // $.each(result.data.data, function(key, value) {
                        //     let paymentMethods = [];
                        //     if (value.status && value.partial) {
                        //         if (value.splitorderpayment.length > 0) {
                        //             $.each(value.splitorderpayment, function(key, value) {
                        //                 paymentMethods.push(value.paymentmethod.payment_method)
                        //             })
                        //         } else {
                        //             paymentMethods.push(value.paymentmethod.payment_method)
                        //         }
                        //     } else if (!value.status && value.partial) {
                        //         $.each(value.splitorderpayment, function(key, value) {
                        //             paymentMethods.push(value.paymentmethod.payment_method)
                        //         })
                        //     } else if (value.status && !value.partial) {
                        //         paymentMethods.push(value.paymentmethod.payment_method)
                        //     }
                        //     orderItems.push({
                        //         "id": value.id,
                        //         "order": value.order,
                        //         "date": moment(value.created_at).format('DD-MM-YYYY'),
                        //         "time": moment(value.created_at).format('hh:mm A'),
                        //         "amount": value.total_amount,
                        //         "modes": paymentMethods,
                        //         status: value.status,
                        //         is_verified: value.is_verified,
                        //         deleted_at:value.deleted_at
                        //     });
                        // });
                        this.items = result.data.orders.data;
                        this.paymentSummary = result.data.totals;
                        // let orderssize = result.data.data.length - 1;
                        this.isLoadingOrdersDone = true
                        // this.orderDetails(this.orders[orderssize].id);
                    }).catch(error => {});
            },
            nextPage() {
                this.current_page_url = this.next_page_url;
                this.displayOrders();
                // let orderssize = result.data.length - 1;
            },
            prevPage() {
                this.current_page_url = this.prev_page_url;
                this.displayOrders();
            },
            OrderSource(source) {
                if (source === 0) {
                    this.ordersource = '';
                    $('#walkin').removeClass('active');
                    $('#allsource').addClass('active');
                    $('#onlineorders').removeClass('active');
                    this.displayOrders(this.current_page_url)
                }
                if (source === 1) {
                    this.ordersource = 0;
                    $('#walkin').addClass('active');
                    $('#allsource').removeClass('active');
                    $('#onlineorders').removeClass('active');
                    this.displayOrders(this.current_page_url)
                }
                if (source === 2) {
                    this.ordersource = 1;
                    $('#walkin').removeClass('active');
                    $('#allsource').removeClass('active');
                    $('#onlineorders').addClass('active');
                    this.displayOrders(this.current_page_url)
                }
            },
            loadorderDetails() {
                const urlParams = new URLSearchParams(window.location.search);
                // Check if the 'bulk-action' parameter exists
                if (urlParams.has('start-date') && urlParams.has('end-date')) {
                    this.dateRange.startDate = moment.utc(urlParams.get('start-date')).startOf('day').toISOString();
                    this.dateRange.endDate = moment.utc(urlParams.get('end-date')).endOf('day').toISOString();
                }
                if (this.orderNumberUrl) {
                    this.$refs.orderDetailsModal.show()
                    this.orderDetailsByOrderNumber(this.orderNumberUrl);
                }
                this.displayOrders();
            },
            orderDetailsByOrderNumber(order) {
                axios.get('/api/order-details', {
                        params: {
                            order_number: order
                        }
                    })
                    .then(result => {
                        this.orderToShow = result.data.order;
                        this.customer = result.data.customer;
                        // this.orderItems = result.data.orderitems;
                        this.totalQuantity = this.orderToShow.orders.reduce((accumulator, item) => accumulator + item.qty, 0);
                        // on click scroll back to top
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    });
            },
            orderDetails(order_id) {
                axios.get('/api/order-details', {
                        params: {
                            order_id: order_id
                        }
                    })
                    .then(result => {
                        this.orderToShow = result.data.order;
                        this.customer = result.data.customer;
                        // this.orderItems = result.data.orderitems;
                        this.totalQuantity = this.orderToShow.orders.reduce((accumulator, item) => accumulator + item.qty, 0);
                        // on click scroll back to top
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    });
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                this.daterange = formattedDates;
                return formattedDates
            },
            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
            getStatusColor(status) {
                switch (status) {
                    case 'pending':
                        return 'text-secondary'; // Gray
                    case 'in_progress':
                        return 'text-info'; // Blue
                    case 'done':
                        return 'text-success'; // Green
                    case 'cancelled':
                        return 'text-danger'; // Red
                    default:
                        return 'text-muted'; // Fallback
                }
            }
        },
    }
</script>

<style scoped>
    .table-orders .order-to-click {
        color: #171717;
        font-size: 13.5px;
        font-weight: 500;
    }
    .table-orders .order-to-click:hover {
        cursor: wait;
    }
    .circle-icon-danger {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #e3342f solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }
    .circle-icon-warning {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #000 solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }
    .circle-icon-success {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px #38c172 solid;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        padding: 3px;
        box-sizing: border-box;
    }
</style>
